import { Modal } from '@components';
import { useScreenSize } from '@hooks';
import { Button, Flex, theme, Typography } from '@styles';
import { arrayOf, bool, func, object } from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

const ChangeCourseModalLayout = ({
  courses,
  isVisible,
  setCurrentCourse,
  setIsVisible,
}) => {
  const { i18n } = useTranslation();
  const { isTabletSM } = useScreenSize();

  const handleSetCourse = (courseKey) => () => {
    setCurrentCourse(courseKey);
  };

  return (
    <Modal
      isVisible={isVisible}
      modalContainerProps={{
        backgroundColor: theme.colors.white[10],
        border: `1px solid ${theme.colors.white[10]}`,
        borderRadius: '0px',
        height: isTabletSM ? '100vh' : '500px',
        maxHeight: isTabletSM ? '100vh' : '500px',
      }}
      setModalVisible={setIsVisible}
      withBackdropNoise
    >
      <Flex
        flexDirection="column"
        height={isTabletSM ? '100vh' : 'auto'}
        overflow="auto"
        pb={100}
        pt={40}
        px={40}
      >
        <Typography
          color={theme.colors.white[100]}
          mb={4}
          variant="MS-semibold-s24-lh36"
        >
          {i18n.t('LearningMapPage.ChooseProgram')}
        </Typography>
        <Flex flexDirection={isTabletSM ? 'column' : 'row'} gap={24}>
          <Button
            alignItems="flex-start"
            backgroundColor={theme.colors.white[10]}
            border={0}
            height="100%"
            maxWidth={isTabletSM ? '100%' : 388}
            onClick={handleSetCourse(courses?.[0]?.id)}
            variant="quaternary"
            width="100%"
          >
            <Flex flexDirection="column" px={24} py={40}>
              <Typography
                color={theme.colors.white[100]}
                mb={10}
                textAlign="left"
                variant="BN-bold-s43-lh38"
              >
                {courses?.[0]?.title}
              </Typography>
              <Typography
                color={theme.colors.white[60]}
                textAlign="left"
                variant="MS-regular-s14-lh22"
              >
                {courses?.[0]?.description}
              </Typography>
            </Flex>
          </Button>
          {Boolean(courses?.[1]) && (
            <Button
              alignItems="flex-start"
              backgroundColor={theme.colors.white[10]}
              border={0}
              height="100%"
              maxWidth={isTabletSM ? '100%' : 388}
              onClick={handleSetCourse(courses?.[1]?.id)}
              variant="quaternary"
              width="100%"
            >
              <Flex flexDirection="column" px={24} py={40}>
                <Typography
                  color={theme.colors.white[100]}
                  mb={10}
                  textAlign="left"
                  variant="BN-bold-s43-lh38"
                >
                  {/* {i18n.t('CoursesPage.OfficerLevel.Title')} */}
                  {courses?.[1]?.title}
                </Typography>
                <Typography
                  color={theme.colors.white[60]}
                  // maxWidth={350}
                  textAlign="left"
                  variant="MS-regular-s14-lh22"
                >
                  {/* {i18n.t('CoursesPage.OfficerLevel.Description')} */}
                  {courses?.[1]?.description}
                </Typography>
              </Flex>
            </Button>
          )}
        </Flex>
      </Flex>
    </Modal>
  );
};

ChangeCourseModalLayout.propTypes = {
  courses: arrayOf(object).isRequired,
  isVisible: bool.isRequired,
  setCurrentCourse: func.isRequired,
  setIsVisible: func.isRequired,
};

export default ChangeCourseModalLayout;
